import { useUserHasScopedBlockAccess, useZocksQuota } from '../../components/ScopedBlock/hooks'
import { useGetBiDashboardsQuery } from '../../shared/insights/store/insights'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'

import './UserAnalytics.scss'

interface UseUserAnalyticsTabsProps {
  userId: string
}

export const useUserAnalyticsTabs = ({ userId }: UseUserAnalyticsTabsProps) => {
  const accountId = useAppSelector(selectAccountId)

  const scope = { scope: 'dashboard:list', superScope: ['dashboard:admin'] }
  const { userHasScopedBlockAccess } = useUserHasScopedBlockAccess()
  const [userHasAccess] = userHasScopedBlockAccess([], undefined, scope)

  const { data: dashboards, isLoading: dashboardsIsLoading } = useGetBiDashboardsQuery(
    {
      accountId,
      filters: [{ filterKey: 'userId', filterValue: userId, filterOperator: 'equals' }],
      dashboardIds: ['user_analytics'],
    },
    { skip: !userHasAccess },
  )

  const { hasQuota, isFetching: quotasIsFetching } = useZocksQuota()
  const dashboardAvailable = hasQuota('insights.enabled.value')

  return { dashboards, dashboardAvailable, userHasAccess, isLoading: dashboardsIsLoading || quotasIsFetching }
}
